import React from "react";

const Label = React.forwardRef(
  ({ className, htmlFor, children, ...props }, ref) => {
    return (
      <label
        htmlFor={htmlFor}
        className={`block text-sm font-medium text-on-surface mb-1 ${className || ""}`}
        ref={ref}
        {...props}
      >
        {children}
      </label>
    );
  },
);

Label.displayName = "Label";

export default Label;
